import React from "react";

const Line = () => {
    return(
    <div className="flex justify-center mt-10">
        <div className="border-t border-white w-5/6"></div>
    </div>
    )
}

export default Line;